module.exports = __webpack_public_path__ + "img/2.fef16a91.png";